import { render, staticRenderFns } from "./funingcunDetails.vue?vue&type=template&id=2f8d02ad"
import script from "./funingcunDetails.vue?vue&type=script&lang=js"
export * from "./funingcunDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports